<div class="confetti-field" aria-hidden="true">
    @for (piece of pieces; track piece) {
        <i class="piece"></i>
    }
</div>
